<template>
  <Drawer width="400" v-model="drawerOpened" :title="'新增客户开发'">
    <div class="drawer-content">
      <Form
        ref="formItem"
        :model="formItem"
        :rules="ruleValidate"
        label-position="top"
      >
        <FormItem label="客户" prop="customer" style="width: 366px">
          <Select
            v-model="formItem.customer"
            filterable
            remote
            clearable
            style="width: 350px"
            :remote-method="searchPublicSea"
            :loading="customerLoading"
            placeholder="请填写客户名字后选择"
          >
            <Option
              v-for="option in canApplyCustomersList"
              :value="option._id"
              :key="option._id"
              style="width: 350px"
              >{{ option.name }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="创建日期" prop="expiredAt" style="width: 366px">
          <div>{{ startTime }}</div>
        </FormItem>
        <FormItem label="截止日期" prop="expiredAt" style="width: 366px">
          <div>{{ formItem.expiredAt }}</div>
        </FormItem>
        <FormItem label="开发途径" prop="developMethod" style="width: 366px">
          <Select
            v-model="formItem.developMethod"
            style="width: 200px"
            @on-change="choseWay"
          >
            <Option v-for="item in way" :value="item.value" :key="item.value">{{
              item.label
            }}</Option>
          </Select>
        </FormItem>
        <FormItem label="申请人" prop="responsiblePerson" style="width: 366px">
          <Select
            v-model="formItem.responsiblePerson"
            filterable
            :remote-method="searchResponsiblePerson"
            style="width: 200px"
            @on-change="choseResponsiblePerson"
          >
            <Option
              v-for="item in responsiblePersonMember"
              :value="item._id"
              :key="item._id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="部门" prop="department" style="width: 366px">
          <Select
            v-model="formItem.department"
            style="width: 200px"
            @on-change="choseDepartment"
          >
            <Option
              v-for="item in departmentList"
              :value="item._id"
              :key="item._id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="申请内容" prop="remark" style="width: 366px">
          <Input
            v-model="formItem.remark"
            type="textarea"
            placeholder="填申请内容"
          />
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit('formItem')">保存</Button>
        </FormItem>
      </Form>
    </div>
  </Drawer>
</template>

<script>
import dayjs from "dayjs";
import { mapState, mapActions } from "vuex";

export default {
  props: {
    loadCustomerDevelop: {
      type: Function,
      default: null,
    },
  },
  name: "CreateCustomerDevelop",
  data() {
    return {
      page: 0,
      drawerOpened: false,
      customerLoading: false,
      canApplyCustomersList: [],
      formItem: {
        customer: undefined,
        expiredAt: dayjs().add(3, "month").format("YYYY-MM-DD"),
        developMethod: undefined,
        department: undefined,
        remark: undefined,
      },
      startTime: dayjs().format("YYYY-MM-DD"),
      way: [
        {
          value: "新客户拜访",
          label: "新客户拜访",
        },
        {
          value: "老客户介绍",
          label: "老客户介绍",
        },
        {
          value: "朋友介绍",
          label: "朋友介绍",
        },
        {
          value: "同事介绍",
          label: "同事介绍",
        },
      ],
      responsiblePerson: "",
      developMethod: "",
      ruleValidate: {
        customer: [
          { required: true, message: "名字为必填项", trigger: "submit" },
        ],
        developMethod: [
          { required: true, message: "开发途径为必选项", trigger: "submit" },
        ],
        department: [
          { required: true, message: "部门为必选项", trigger: "submit" },
        ],
        responsiblePerson: [
          { required: true, message: "申请人为必选项", trigger: "submit" },
        ],
      },
      responsiblePersonMember: [],
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.currentUser,
      customers: (state) => state.customer.customers,
      departmentList: (state) => state.department.departmentList,
    }),
  },

  methods: {
    ...mapActions({
      getCustomers: "customer/getCustomersAction",
      getAllCustomerList: "customer/getAllCustomerListAction",
      getCustomerDevelop: "customerDevelop/getCustomerDevelopAction",
      getUsersList: "user/getUsersAction",
      getDepartmentList: "department/getDepartmentListAction",
      creatCustomerDevelop: "customerDevelop/creatCustomerDevelopAction",
    }),
    async openDrawer() {
      this.getDepartmentList();
      this.drawerOpened = true;
    },

    async searchPublicSea(searschText) {
      let api = { isSupplying: false, exists: false };
      if (searschText && searschText.trim() !== "") {
        api.name = searschText;
      } else {
        delete api.name;
      }
      try {
        const data = await this.getAllCustomerList(api);
        let canApplyCustomersList = data.customerList.filter((x) => {
          return !x.customerDevelop;
        });
        this.canApplyCustomersList = canApplyCustomersList;
      } catch (error) {
        this.$Message.error(`加载失败: ${error}`);
      }
    },

    choseWay(way) {
      if (way) {
        this.formItem.developMethod = way;
      }
    },
    async searchResponsiblePerson(searschText) {
      let api = {};
      if (searschText && searschText.trim() !== "") {
        api.userName = searschText;
      } else {
        delete api.userName;
      }
      try {
        const data = await this.getUsersList(api);
        const userList = data.userList;

        let responsiblePersonMember = userList.filter((x) => {
          for (let i = 0; i < x.simpleRole.length; i++) {
            if (
              ["sales", "salesDirector", "salesLead"].indexOf(x.simpleRole[i]) >
              -1
            ) {
              return x;
            }
          }
        });
        this.responsiblePersonMember = responsiblePersonMember;
      } catch (error) {
        this.$Message.error(`加载失败: ${error}`);
      }
    },
    choseResponsiblePerson(responsiblePerson) {
      if (responsiblePerson) {
        this.formItem.responsiblePerson = responsiblePerson;
      }
    },
    // 部门选择
    choseDepartment(department) {
      if (department) {
        this.formItem.department = department;
      }
    },
    handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          try {
            if (!this.formItem.remark) {
              delete this.formItem.remark;
            }
            await this.creatCustomerDevelop(this.formItem);
            this.$Message.success("创建成功!");
            this.drawerOpened = false;
            this.formItem.customer = undefined;
            this.formItem.developMethod = undefined;
            this.formItem.department = undefined;
            this.formItem.remark = undefined;
            this.loadCustomerDevelop();
          } catch (error) {
            this.$Message.error(`失败: ${error}`);
          }
        } else {
          this.$Message.error("创建失败!");
        }
      });
    },
  },
};
</script>

<style>
</style>

